import(/* webpackMode: "eager" */ "/home/ubuntu/Webkorps-Website/src/assets/images/android-app-development-services.jpg");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/Webkorps-Website/src/assets/images/dot-net-development-services.jpg");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/Webkorps-Website/src/assets/images/ios-app-development-services.jpg");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/Webkorps-Website/src/assets/images/java-development-services.jpg");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/Webkorps-Website/src/assets/images/php-development-services.jpg");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/Webkorps-Website/src/assets/images/python-development-services.jpg");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/Webkorps-Website/src/assets/images/react-native-app-development-services.jpg");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/Webkorps-Website/src/assets/images/ror-development-services.jpg");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/Webkorps-Website/src/components/pages/TechnologyPage.jsx");
